import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormCallback from '@ertelecom/ui-react/components/FormCallback';
import CallToActionText from './CallToActionText';
import { getCityFromHostName } from '../../../helpers/url';
import {
    sendRequestByConnection,
    parseRequestByConnection,
    dataLayerForCBPhonePushWrapper,
} from '~/src/api/service-request/request-by-connection';
import cookie from 'react-cookies';
import { Wrapper, Item, Form, FormTitle } from './styled';
import { getClientId } from '~/src/helpers/clientInfo';
import Router from 'next/router';
import { ACTIONS } from '~/src/constants/analytics';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

class CallToActionBlock extends PureComponent {

    constructor() {
        super();
        this.clearPhone = undefined;
    }

    formCallbackRef = React.createRef();

    static propTypes = {
        productId: PropTypes.string,
        label: PropTypes.string,
        itemsCallToActionText: PropTypes.array,
        plan: PropTypes.string,
        cityId: PropTypes.string,
        gaCid: PropTypes.string,
        rightTitle: PropTypes.string,
        title: PropTypes.node
    };

    static defaultProps = {
        productId: '0',
        itemsCallToActionText: []
    };

    state = {
        valueName: '',
        valueContact: '',
        nameValidated: false,
        contactValidated: false,
        formMessage: '',
        formState: '',
        waitStatus: true,
        beenStarted: false,
    };

    render() {

        const { submitForm, onChangeNameHandler, onChangeContactHandler } = this;

        const { itemsCallToActionText, title, rightTitle } = this.props;

        const {
            nameValidated,
            contactValidated,
            valueName,
            valueContact,
            waitStatus
        } = this.state;

        return (
            <Wrapper>
                <Item>
                    <Form data-test='callback-form' ref={node => this.wrapperForm = node}>
                        <FormTitle ref={node => this.titleForm = node}>
                            {title}
                        </FormTitle>
                        <FormCallback
                            ref={this.formCallbackRef}
                            placeholderName='Ваше имя'
                            placeholderContact='Номер телефона'
                            errorMessageName='Ожидаются только буквы и дефисы'
                            errorMessageContact='Введите номер в формате +7 (999) 999-99-99'
                            textButton='Отправить заявку'
                            onSubmitHandler={submitForm}
                            disabledButton={!nameValidated || !contactValidated}
                            onChangeNameHandler={onChangeNameHandler}
                            onChangeContactHandler={onChangeContactHandler}
                            valueName={valueName}
                            valueContact={valueContact}
                            waitStatus={waitStatus}
                            buttonText='Отправить заявку'
                        />
                    </Form>
                </Item>
                {
                    this.props.itemsCallToActionText.length &&
                    <Item>
                        <CallToActionText
                            title={rightTitle || 'Как подключиться?'}
                            items={itemsCallToActionText}
                        />
                    </Item>
                }
            </Wrapper>
        );
    }

    dataLayerPushWrapper = () => {
        const { beenStarted } = this.state;
        const { label = '' } = this.props;
        if (beenStarted) {
            return;
        }
        dataLayerForCBPhonePush({ action: ACTIONS.started, requestId: null, option: label });
        this.setState({ beenStarted: true });
    };

    onChangeNameHandler = value => {
        this.setState({ valueName: value });
        if (value.length >= 2 && !(/[0-9!"№;%:\?\*\(\)_\+=~\[\]`@#\$\^&{},\.<>/\|\\/\'\"]/).test(value)) {
            this.setState({ nameValidated: true });
        } else {
            this.setState({ nameValidated: false });
        }
        this.dataLayerPushWrapper();
    };

    onChangeContactHandler = data => {
        if (!this.clearPhone) {
            this.clearPhone = data.clearInput;
        }
        this.setState({
            valueContact: data.value,
            contactValidated: data.isValid,
        });
        this.dataLayerPushWrapper();
    };

    formSuccess = message => {
        this.formCallbackRef.current.formSuccess(message);
        this.clearPhone();
        this.setState({ valueName: '', valueContact: '', waitStatus: true });
        if (Router.pathname == '/domofon' || Router.pathname == '/domofon/tariffs') {
            Router.push('/domofon/meeting');
        }
    };

    formError = message => {
        this.formCallbackRef.current.formError(message);
        this.setState({ waitStatus: true });
    };

    submitForm = (event) => {

        event.preventDefault();

        const { valueName, valueContact } = this.state;

        const { productId, cityId, label = '' } = this.props;

        this.setState({ waitStatus: false });

        const cityDomain = getCityFromHostName(document.location.hostname);

        const clientId = cookie.load('_ga_cid');

        const dataParams = {
            petition: 'create_request',
            fio: valueName,
            phone: valueContact,
            domain: cityDomain,
            product_id: productId,
            city_id: cityId || '',
            ga_cid: clientId ? clientId : getClientId(),
        };

        sendRequestByConnection(cityDomain, dataParams)
            .then(res => {
                const { ok, message } = parseRequestByConnection(res);
                dataLayerForCBPhonePushWrapper({ ...res, option: label });
                if (ok) {
                    this.formSuccess(message);
                } else {
                    this.formError(message);
                }
            })
            .catch(() => {
                this.formError();
                dataLayerForCBPhonePush({
                    requestId: null,
                    action: ACTIONS.error,
                });
            });
    };

    componentDidMount() {
        this.restylingComponent();
        if (process.browser) {
            window.addEventListener('resize', this.restylingComponent);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.restylingComponent);
    }

    restylingComponent = () => {

        const { wrapperForm, titleForm } = this;

        if (wrapperForm.offsetWidth < 453) {
            wrapperForm.style.padding = '35px 20px';
            titleForm.style.fontSize = '20px';
        } else {
            wrapperForm.style.padding = '35px 36px';
            titleForm.style.fontSize = '24px';
        }
    }
}

export default CallToActionBlock;
